<!--
/**
* @name: List.vue
* @description: 收支明细-列表页面
* @author: 杨波
* @create: 2020/12/21 14:06:58
* @update: 2020/12/21 14:06:58
*/
-->
<template>
  <y-view :loading="isLoading">
    <y-query spaceBetween :hasSearchButton="false">
      <y-query-item>
        <k-input :class="css.inputW" placeholder="请输入会员账号" clearable v-model="para.shopMemberAccount"></k-input>
      </y-query-item>
      <y-query-item>
        <k-select :class="css.inputW" placeholder="请选择业务类型" block clearable v-model="para.biz">
          <k-option v-for="item in businessTypeList" :key="item.code" :value="item.code" :label="item.name">{{ item.name }}</k-option>
        </k-select>
      </y-query-item>
      <y-query-item>
        <k-input :class="css.inputW" placeholder="请输入业务单据号" clearable v-model="para.bizNo"></k-input>
      </y-query-item>
    </y-query>
    <y-query spaceBetween :hasSearchButton="false">
      <y-query-item>
        <DatePicker
          :editable="false"
          type="datetimerange"
          @on-change="changeCreateDate"
          :value="createDate"
          format="yyyy-MM-dd HH:mm:ss"
          placeholder="请选择创建时间"
          style="width: 280px;"
        ></DatePicker>
      </y-query-item>
      <y-query-item>
        <k-button type="primary" @click="onSearch">查询</k-button>
      </y-query-item>
      <y-query-item>
        <k-button @click="onReset">重置</k-button>
      </y-query-item>
    </y-query>
    <k-table :data="incomeList" :height="$root.tableHeightXX" :rightFixedNumber="1" :columns="initColumns()"></k-table>
    <k-pagination :total="total" :current-page.sync="para.pageCurrent" :page-size.sync="para.pageSize" @page-change="onChangePageIndex" />
  </y-view>
</template>
<script>
import { NESTLE_FINANCE_BACK_SERVER_FLOW_LIST, NESTLE_FINANCE_BACK_SERVER_FLOW_LIST_OPTIONS } from "@/assets/modules/apiList";
const initPara = () => ({
  shopMemberAccount: "", //会员账号
  biz: "", //业务类型
  bizNo: "", //业务单据号
  pageCurrent: 1,
  pageSize: 15,
  createStartTime: "",
  createEndTime: "",
});
export default {
  data() {
    return {
      isLoading: false,
      para: initPara(),
      incomeList: [],
      total: 0,
      businessTypeList: [], //业务类型列表
      createDate: "", //创建时间
    };
  },
  methods: {
    initColumns() {
      return [
        {
          name: "ID",
          field: "id",
          style: {
            width: 80,
            textAlign: "center",
          },
        },
        {
          name: "会员账号",
          field: "shopMemberAccount",
          style: {
            width: 80,
            textAlign: "center",
          },
        },
        {
          name: "会员名称",
          field: "shopMemberName",
          style: {
            width: 80,
            textAlign: "center",
            "line-height": "18px",
            "white-space": "normal",
            "word-break": "break-all",
          }
        },
        {
          name: "业务类型",
          field: "bizDesc",
          style: {
            width: 100,
            textAlign: "center",
            "line-height": "18px",
            "white-space": "normal",
          },
        },
        {
          name: "角色",
          field: "shopMemberTypeDesc",
          style: {
            width: 80,
            textAlign: "center",
            "line-height": "18px",
            "white-space": "normal",
            "word-break": "break-all",
          },
        },
        {
          name: "业务单据号",
          field: "bizNo",
          style: {
            width: 150,
            textAlign: "center",
            "line-height": "18px",
            "white-space": "normal",
            "word-break": "break-all",
          },
        },
        {
          name: "发生额",
          field: "amount",
          style: {
            width: 100,
            textAlign: "center",
            "line-height": "18px",
            "white-space": "normal",
          },
        },
        {
          name: "变动后总额",
          field: "balanceTotal",
          style: {
            width: 100,
            textAlign: "center",
            "line-height": "18px",
            "white-space": "normal",
          },
        },
        {
          name: "变动后可用余额",
          field: "balanceUsable",
          style: {
            width: 100,
            textAlign: "center",
            "line-height": "18px",
            "white-space": "normal",
          },
        },
        {
          name: "变动后冻结余额",
          field: "balanceFrozen",
          style: {
            width: 100,
            textAlign: "center",
            "line-height": "18px",
            "white-space": "normal",
          },
        },
        {
          name: "备注",
          field: "comment",
          style: {
            width: 100,
            textAlign: "center",
            "line-height": "18px",
            "white-space": "normal",
            "word-break": "break-all",
          },
        },
        {
          name: "操作人",
          field: "createBy",
          style: {
            width: 100,
            textAlign: "center",
            "line-height": "18px",
            "white-space": "normal",
          },
        },
        {
          name: "创建时间",
          field: "createTime",
          style: {
            width: 130,
            textAlign: "center",
            "line-height": "18px",
            "white-space": "normal",
          },
        },
      ];
    },
    changeCreateDate(date) {
      this.createDate = date;
    },
    //条件查询
    onSearch() {
      this.para.pageCurrent = 1;
      this.getIncomeList();
    },
    //重置查询条件
    onReset() {
      this.para = initPara();
      this.createDate = "";
      this.getIncomeList();
    },
    //分页查询操作
    onChangePageIndex(p) {
      this.para.pageCurrent = p;
      this.getIncomeList();
    },
    //获取列表数据
    getIncomeList() {
      let { para } = this;
      this.isLoading = true;
      para.createStartTime = this.createDate && this.createDate.length > 0 ? this.createDate[0] : "";
      para.createEndTime = this.createDate && this.createDate.length > 0 ? this.createDate[1] : "";
      this.$fetch({
        api: NESTLE_FINANCE_BACK_SERVER_FLOW_LIST,
        para,
      }).then((res) => {
        this.isLoading = false;
        this.incomeList = res.pageList || [];
        this.total = res.total;
      });
    },
    getOptionsList() {
      this.$fetch({
        api: NESTLE_FINANCE_BACK_SERVER_FLOW_LIST_OPTIONS,
        para: {},
      }).then((res) => {
        this.businessTypeList = res.bizList || [];
      });
    },
  },
  created() {
    this.getIncomeList();
    this.getOptionsList();
  },
  beforeRouteUpdate(to, from, next) {
    this.getIncomeList();
    next();
  },
};
</script>
<style lang="postcss" module="css">
.inputW {
  width: 280px !important;
}
</style>
